import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createStoreCountriesUrl } from "@is/services/api";

type StoreLanguageResponse = {
  items: string[];
  totalCount: number;
  count: number;
  pageSize: number;
  page: number;
};

export const useStoreCountries = () => {
  const { setApiHeaders, storeId, countryCode } = useManageApiHeaders();

  setApiHeaders();

  const url = createStoreCountriesUrl(storeId);

  const shouldSearch = storeId && !countryCode;

  const { data, error, isLoading } = useSWR(shouldSearch && url, api.get);

  return {
    countries: (data as StoreLanguageResponse)?.items,
    isLoading,
    error,
  };
};
